import { useState } from "react";
import MMYLPOverview from "./MmyLpOverview";
import StakeNFT from "./StakeNFT";
import StakingLP from "./StakingLP";
const Tabs = ["Lock", "Stake"]
const LockStakeLP = ({ setPendingTxns, pendingTxns, userInfo, connectWallet }) => {
  const [currentTab, setCurrentTab] = useState("Lock")
  return (
    <div className="lock-stake-container">
      <div className="tab-lock-contaier">
        {Tabs.map(item => (
          <div onClick={() => setCurrentTab(item)}
            className={`tab-lock ${item === currentTab ? 'tab-lock-active' : ''}`} key={item}>{item}</div>
        ))}
      </div>
      <div className="content-container">
        {
          currentTab === "Lock" ? <div className="bottom-require-container">
          <StakeNFT setPendingTxns={setPendingTxns} pendingTxns={pendingTxns} connectWallet={connectWallet} />
          <MMYLPOverview userInfo={userInfo} setPendingTxns={setPendingTxns} pendingTxns={pendingTxns} connectWallet={connectWallet} />
          {/* <VestingOverview userInfo={userInfo} setPendingTxns={setPendingTxns} pendingTxns={pendingTxns} connectWallet={connectWallet} /> */}
        </div> : <div className="bottom-require-container">
          <StakingLP/>
        </div>
        }
      </div>
    </div>
  )
}
export default LockStakeLP;
